import type { Meta, StoryObj } from '@storybook/angular';
import { BellIconComponent } from '../../../app/core/svg-icons/bell-icon.component';

const meta: Meta<BellIconComponent> = {
  title: 'Atoms/Icons/BellIcon',
  component: BellIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A bell/notification icon component. Used for the "Dagens vin" header item to open AnnounceKit.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<BellIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-bell-icon></app-bell-icon>',
  }),
};

export const InNavigation: Story = {
  render: () => ({
    template: `
      <nav style="background-color: #5C0A31; padding: 1rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem; color: white; flex-direction: column; width: fit-content;">
          <app-bell-icon></app-bell-icon>
          <span style="font-size: 12px;">Dagens vin</span>
        </div>
      </nav>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Bell icon in header navigation context, as used for the "Dagens vin" menu item.',
      },
    },
  },
};
